import React, { useEffect, useState } from "react";
import DialogBox from "../../components/DialogBox";
import TermsAndConditionsModal from "../../components/TermsAndConditions";
import axiosApi from "../../components/Api/Axios";
import BackendServices from "../../components/Api/BackendService";
import Snackbar from "../../components/Snackbar";

interface TermsAndConditionsProps  {
    children: React.ReactNode
}
const TermsAndConditionsProvider = ({children}: TermsAndConditionsProps) => {

    const [termsAccepted, setTermsAccepted] = useState<boolean>(false);
    const [open, setOpen] = useState<boolean>(false);
    const [postState, setPostState] = useState<'loading' | 'failed' | 'success' | 'initial'>('initial');
    const [message, setMessage] = useState<string>('');
    const [snackbarOpen, setSnackbarOpen] = useState<boolean>(false);
    
    useEffect(() => {
        checkTermStatus();
    }, [])

    const checkTermStatus = () => {
        axiosApi.get(`${BackendServices.USER_SERVICE.USER}/isPrivacyPolicyTcAcceptedByUser`)
        .then(response => response.data ? setTermsAccepted(true) : (setTermsAccepted(false), setOpen(true)))
    }

    const acceptTerms = () => {
        setPostState('loading');
        axiosApi.post(`${BackendServices.USER_SERVICE.USER}/AcceptPrivacyPolicyTC`)
        .then((response) => { 
            if(response.status == 200)
            {
                setPostState('success')
                setOpen(false);
                setTermsAccepted(true);
                setMessage(response.data);
                setSnackbarOpen(true);
                return;
            }

            setPostState('failed')
            setSnackbarOpen(true);
            setMessage(
              "There was an error accepting Terms and Conditions. Please try again."
            );
        })
        
    }

    return (
      <>
        {!termsAccepted && (
            <DialogBox
            acceptButtonText="Accept"
            open={open}
            onCancel={() => {}}
            onConfirm={acceptTerms}
            disabled={postState == "loading"}
            >
            <TermsAndConditionsModal />
          </DialogBox>
        )} 
        {children}
        <Snackbar
          close={() => setSnackbarOpen(false)}
          message={message}
          type={postState == "success" ? "success" : "error"}
          open={snackbarOpen}
        />
      </>
    );
}

export default TermsAndConditionsProvider;